import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { motion } from 'framer-motion';

const ClosingSection = () => {
  const { t } = useLanguage();

  return (
    <section 
      className="py-20 md:py-28 bg-white"
      data-testid="closing-section"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="max-w-4xl mx-auto text-center"
        >
          <div className="flex justify-center mb-8">
            <div className="w-16 h-px bg-[#C5A059]" />
          </div>
          <blockquote 
            className="text-2xl md:text-3xl lg:text-4xl text-[#1A2F23] font-['Playfair_Display'] italic leading-relaxed"
            data-testid="closing-quote"
          >
            "{t('closing_quote')}"
          </blockquote>
          <div className="flex justify-center mt-8">
            <div className="w-16 h-px bg-[#C5A059]" />
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default ClosingSection;
